module.exports = __webpack_public_path__ + "media/images/our_apps/tablet_mobile-3618022a28638caf5871a5ecae28c915.png";